import * as FileSaver from 'file-saver';

export function downloadCSV(data, fileName = 'Exported emails.csv', isBlob = false) {
  const binData = isBlob ? data : new Blob([data]);
  FileSaver.saveAs(binData, fileName);
}


// WEBPACK FOOTER //
// ./src/utils/file.js